import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import "./teacherForm.scss"
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, FieldArray } from "formik";
import { StoreContext } from '../../store/context'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { PAYMENT_TYPE_TEACHER_HOUR, PAYMENT_TYPE_TEACHER_RATIO } from './../../utils/constants';
import {registrationStates} from "../../store/reducers/registrationReducer";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const TeacherManagementForm = () => {
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { uuid, name, phoneNo, gender, idNo, bankName, bankAccountNo, paymentType, paymentRate} = state.formStates.teacherRegistration;
    const { courses, programLvl } = state.registrationStates;
    const { setFormData } = actions.formActions; // export setFormData function
    const { teacher } = state.generalStates;
    const { banks } = state.generalStates;
    const { getAllBanks, displayConfirmDialog } = actions.generalActions;
    const { getAllCourses, getAllProgramLvl, cancelTuitionCourse, updateTeacherInfo } = actions.registrationActions; // export setFormData function
    const [ paymentTypeState, setPaymentTypeState] = useState(paymentType);

    useEffect(() => {
        getAllCourses();
        getAllProgramLvl();
        getAllBanks();
    }, []);

    const handlePaymentTypeChange = (e, { value }, setFieldValue) =>{
        setFieldValue('paymentType', e.target.value);
        setPaymentTypeState(e.target.value)
    };

    const handlePaymentRateChange = (e, value , setFieldValue) =>{
        const re = /\d*([\/]?\d+)/;
        // if value is not blank, then test the regex
        if (e.target.value === '' || re.test(e.target.value)) {
            setFieldValue('paymentRate', e.target.value);
        }
    };

    const removeTuitionCourse = (arrayHelpers, values, index) => {
        // const tuitionCourse = arrayHelpers.get(index);
        const tuitionCourse = values.tuitionCourse[index];
        cancelTuitionCourse(tuitionCourse.id);
        arrayHelpers.remove(index);
    }

    const renderPaymentField = (setFieldValue) =>{
        const labelTxt = paymentTypeState === PAYMENT_TYPE_TEACHER_RATIO ? "Split Ratio (Teacher/Centre)" : "Hourly Rate (RM)";
        const placeHolderTxt = paymentTypeState === PAYMENT_TYPE_TEACHER_RATIO ? "4/6" : "20";
        return (
            <div className="input-field-container">
                <Field name="paymentRate">
                    {({field, form: {touched, errors}}) => (
                        <>
                            <TextField {...field} label={labelTxt} variant="filled" className="input-field"
                                       placeholder={placeHolderTxt}
                                       onChange={(e, val) => handlePaymentRateChange(e, val, setFieldValue)}/>
                        </>
                    )}
                </Field>
            </div>
        )
    };

    const renderAllCourses = (field) =>{
        return (
            <Select {...field}>
                {courses.map((value, index) => {
                        return (
                            <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                        );
                    })
                }
            </Select>
        )
    };

    const goBack = () => {
        history.push("/teacher/management")
    }

    const renderAllProgramLvl = (field) =>{
        return (
            <Select {...field}>
                {
                    programLvl.map((value, index) => {
                        return (
                            <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                        );
                    })
                }
            </Select>
        )
    };

    const renderTuitionCourse = (values) =>{
        return (
            <div>
                <FieldArray
                    name="tuitionCourse"
                    render={arrayHelpers => (
                        <div>
                        {values.tuitionCourse.map((value, index) => {
                            return (
                                <div className="courseContainer" key={index}>
                                    <div className="input-field-container" >
                                        <Field name={`tuitionCourse[${index}].programLvl`}>
                                            {({ field, form: { touched, errors } }) => (
                                                <>
                                                    <FormControl variant="filled" className="input-field" disabled={values.tuitionCourse[index].id != null ? true : false}>
                                                        <InputLabel>Select Program level</InputLabel>
                                                        {renderAllProgramLvl(field)}
                                                    </FormControl>
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="input-field-container" >
                                        <Field name={`tuitionCourse[${index}].subjectId`}>
                                            {({ field, form: { touched, errors } }) => (
                                                <>
                                                    <FormControl variant="filled" className="input-field" disabled={values.tuitionCourse[index].id != null ? true : false}>
                                                        <InputLabel>Select subject</InputLabel>
                                                        {renderAllCourses(field)}
                                                    </FormControl>
                                                </>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="input-field-container">
                                        <Field name={`tuitionCourse[${index}].fee`}>
                                            {({ field, form: { touched, errors } }) => (
                                                <>
                                                    <TextField
                                                        {...field}
                                                        label="Fee"
                                                        variant="filled"
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">RM</InputAdornment>,
                                                        }}
                                                        type="number"
                                                        className="input-field"
                                                        disabled={values.tuitionCourse[index].id != null ? true : false}/>
                                                </>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="button-container">
                                        <IconButton aria-label="delete" onClick={() => {
                                            displayConfirmDialog(
                                                true,
                                                "Confirmation",
                                                "Are you sure you want to delete this?",
                                                true,
                                                () => removeTuitionCourse(arrayHelpers, values, index))
                                        }}><DeleteIcon/>
                                        </IconButton>
                                        {/*<IconButton aria-label="delete" onClick={() => {removeTuitionCourse(arrayHelpers, values, index)}}>*/}
                                        {/*    <DeleteIcon/>*/}
                                        {/*</IconButton>*/}
                                    </div>
                                </div>
                            ) //here
                        })}
                        <div style={{display: "flex", justifyContent: "flex-end", paddingRight: "30px", marginBottom: "12px"}}>
                            <Button variant="contained" color="secondary" onClick={() => arrayHelpers.push({programLvl: 0, subjectName: 0, fee: 0})} className="submit-button">
                                Add more courses
                            </Button>
                        </div>
                    </div>
                    )}
                />
            </div>
        )
    };

    return (
        <div className="form-container">
            <IconButton className="arrowBack" aria-label="back" onClick={() => {goBack()}}>
                <ArrowBackIosIcon fontSize="small" color="primary"/> <span>BACK</span>
            </IconButton>
            <h1 className="header">Teacher Management Form</h1>
            <Formik
                initialValues={{
                    uuid: `${uuid}`,
                    name: `${teacher.name ? teacher.name : ''}`,
                    phoneNo: `${teacher.phoneNo ? teacher.phoneNo.substring(2, teacher.phoneNo.length) : ''}`,
                    email: `${teacher.email ? teacher.email : ''}`,
                    gender: `${teacher.gender ? teacher.gender : ''}`,
                    identification: `${teacher.nric ? teacher.nric : ''}`,
                    paymentType: `${teacher.paymentType ? teacher.paymentType : ''}`,
                    paymentRate: `${teacher.paymentRate ? teacher.paymentRate : ''}`,
                    tuitionCourse:  teacher.tuitionCourses ? teacher.tuitionCourses : [],
                    bankName: `${teacher.bankName ? teacher.bankName : ''}`,
                    bankAccountNo: `${teacher.bankAccountNo ? teacher.bankAccountNo : ''}`,
                }}
                onSubmit={(values, { setSubmitting }) => {
                    // setFormData({teacherRegistration : values});
                    updateTeacherInfo(values, history);
                    setSubmitting(false);
                }}
            >
                {({ isSubmitting, setFieldValue, values }) => (
                    <Form>
                        <h2 className="header">Teacher Info</h2>
                        <div className="input-field-container">
                            <Field name="name">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <TextField {...field} label="Name" variant="filled" className="input-field"/>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="input-field-container">
                            <Field name="phoneNo">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <TextField {...field}
                                                   label="Phone No."
                                                   variant="filled"
                                                   InputProps={{
                                                       startAdornment: <InputAdornment position="start">+60</InputAdornment>,
                                                   }}
                                                   type="number"
                                                   className="input-field"/>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="input-field-container">
                            <Field name="gender">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <FormControl variant="filled" className="input-field">
                                            <InputLabel>Gender</InputLabel>
                                            <Select {...field}>
                                                <MenuItem value={"M"}>Male</MenuItem>
                                                <MenuItem value={"F"}>Female</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="input-field-container">
                            <Field name="identification">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <TextField {...field} label="IC No." variant="filled" className="input-field" placeholder="00000-00-0000"/>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="input-field-container">
                            <Field name="bankName">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <FormControl variant="filled" className="input-field">
                                            <InputLabel>Bank Name</InputLabel>
                                            <Select {...field}>
                                                {
                                                    banks && banks.map((value, index) => {
                                                        return (
                                                            <MenuItem key={value.swiftCode} value={value.swiftCode}>{value.name}</MenuItem>
                                                        );
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="input-field-container">
                            <Field name="bankAccountNo">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <TextField {...field} label="Bank Account No." input="number" variant="filled" className="input-field" placeholder="12345678"/>
                                    </>
                                )}
                            </Field>
                        </div>
                        <div className="input-field-container">
                            <Field name="paymentType">
                                {({ field, form: { touched, errors } }) => (
                                    <>
                                        <FormControl variant="filled" className="input-field">
                                            <InputLabel>Payment Type</InputLabel>
                                            <Select {...field} onChange={(e, val) => handlePaymentTypeChange(e, val, setFieldValue)}>
                                                <MenuItem value={PAYMENT_TYPE_TEACHER_RATIO}>Ratio</MenuItem>
                                                <MenuItem value={PAYMENT_TYPE_TEACHER_HOUR}>Hour</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </>
                                )}
                            </Field>
                        </div>

                        {renderPaymentField(setFieldValue)}

                        <h2 className="header">Courses</h2>
                        {renderTuitionCourse(values)}

                        {/*add few fields*/}


                        {/* default submit button will fire  "onSubmit" function when clicked */}
                        <div>
                            <Button variant="contained" type="submit" color="primary" disabled={isSubmitting} className="submit-button">
                                Submit
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default withRouter(TeacherManagementForm)
